export default "__VITE_ASSET__DCXUVuFa__"